import {observer} from 'mobx-react';
import {lazy} from 'react';

const PasswordCompletePageComp = lazy(() =>
  import('./password-complete-page').then((module) => ({
    default: module.PasswordCompletePage,
  })),
);

export const installPasswordCompletePage = () => {
  const Page = observer(() => <PasswordCompletePageComp />);
  return {
    Page,
  };
};
